import getShorterText from "Common/componentUtils/getShorterText";
import Close from "Components/close";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import isFunction from "lodash/isFunction";
import isString from "lodash/isString";
import React, { useCallback, useMemo } from "react";
import { colorMap, iconMap } from "../popupMessageType";
import MessageLink, { needMessageLink } from "./messageLink";
const SIZES = {
    ICON_COL_WIDTH: 32
};
const counterStyle = {
    letterSpacing: 1,
    scale: "0.9 0.75"
};
export default function Message({ className, data, onClose, onMouseEnter, onMouseLeave }) {
    const handleMessageLinkClick = useCallback(() => {
        var _a;
        isFunction((_a = data.messageLink) === null || _a === void 0 ? void 0 : _a.onClick) && data.messageLink.onClick();
        onClose && onClose(data.id);
    }, [data.id, data.messageLink, onClose]);
    const handleClose = useCallback(() => {
        onClose && onClose(data.id);
    }, [data.id, onClose]);
    const handleMouseEnter = useCallback(() => {
        onMouseEnter && onMouseEnter(data.id);
    }, [data.id, onMouseEnter]);
    const handleMouseLeave = useCallback(() => {
        onMouseLeave && onMouseLeave(data.id);
    }, [data.id, onMouseLeave]);
    const hasMessageLink = useMemo(() => Boolean(needMessageLink(data.messageLink)), [data.messageLink]);
    const colors = useMemo(() => colorMap[data.type], [data.type]);
    const containerStyle = useMemo(() => ({
        border: `1.5px solid ${themeVariables[colors.border]}`,
        backgroundColor: themeVariables[colors.bg],
        boxShadow: themeVariables["btn-primary-dark-shadow-hover"]
    }), [colors]);
    const messageContentStyle = useMemo(() => ({
        gridTemplateColumns: `${SIZES.ICON_COL_WIDTH}px ${hasMessageLink ? "auto " : ""}1fr`
    }), [hasMessageLink]);
    return (React.createElement("div", { className: classNames("caption-with-actions-panel v-center-items border-rounded-medium pt-0_75 pb-0_75 pl-1 pr-1 position-relative", className), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: containerStyle },
        data.count > 1 && (React.createElement("div", { style: counterStyle, className: "position-absolute t-0-l-4 pl-0_25 text-muted" }, `x${data.count}`)),
        React.createElement("div", { style: messageContentStyle, className: "d-grid v-center-items overflow-hidden" },
            React.createElement("div", null,
                React.createElement("i", { className: classNames(iconMap[data.type], "font-h3") })),
            React.createElement("div", null,
                React.createElement("div", { className: "text-overflow-ellipsis text-sys-light-on-surface font-base pre-wrap break-word" }, isString(data.message) ? getShorterText(data.message, 350) : data.message),
                hasMessageLink && (React.createElement("div", { className: "mt-0_5 overflow-hidden d-grid justify-content-start" },
                    React.createElement(MessageLink, { ...data.messageLink, onClick: handleMessageLinkClick }))))),
        React.createElement("div", { className: "pt-0_25" },
            React.createElement(Close, { onClick: handleClose, animateHoverColor: true, fontSize: 10 }))));
}
